<template>
    <z-basePage :title="'BU列表'" class="z-BUlist">
        <div class="search-top">
            <el-input class="top-input" :placeholder="holdertext" v-model="searchText">
                <el-select v-model="searchType" slot="prepend" >
                    <el-option v-for="item in searchOptions" :key="item.val" :label="item.label" :value="item.val"></el-option>
                </el-select>
            </el-input>
            <div class="back-btn shift" @click="searchBu">搜索BU</div>
            <!-- <div class="back-btn blue" @click="addPerson">添加职员</div> -->
            <div class="back-btn blue" @click="newBu">新建BU</div>
            <div class="back-btn red" @click="deleteBu()">删除BU</div>
        </div>

        <div class="back-list page">
            <div class="list-head">
                <div><el-checkbox v-model="checkall" @change="checkList"></el-checkbox></div>
                <div>BU名称</div>
                <div>BU职责</div>
                <div>包含人数</div>
                <div>操作</div>
            </div>
            <z-scrollDiv class="main">
                <el-checkbox-group v-model="deleteIds">
                    <div class="list-item" v-for="item in dataList" :key="item.id">
                        <div><el-checkbox :disabled="item.type !== 0" :label="item.id" @change="changeCheck">{{ "" }}</el-checkbox></div>
                        <div class="overhide"><span class="link-name" @click="link(item)">{{ item.bu_name }}</span></div>
                        <div class="overhide">{{ item.bu_description | placeholder }}</div>
                        <div>{{ `${item.num}人` }}</div>
                        <div>
                            <!-- <a class="download" v-if="item.id == 1">下载模板</a>
                            <div class="back-btn blue" v-if="item.id == 1">导入</div> -->
                            <span class="red" v-if="item.type == 0" @click.stop="deleteBu(item.id)">删除</span>
                        </div>
                    </div>
                </el-checkbox-group>
                <z-noData :list="dataList"></z-noData>
            </z-scrollDiv>
        </div>

    </z-basePage>
</template>

<script>
    import {mapGetters} from "vuex"
    export default {
        data(){
            return {
                searchText:"",
                searchType:1,
                searchOptions:[
                    {
                        label:"BU名称",
                        val:1,
                    },
                    {
                        label:"职员姓名",
                        val:2,
                    },
                ],
                data:{},
                checkall:false,  //全选
                deleteIds:[],  //删除的id
            }
        },

        computed:{
            ...mapGetters(["buList"]),
            holdertext(){  //placeholder
                let res;
                switch (this.searchType) {
                    case 1:
                        res = "请输入BU名称";
                        break;

                    case 2:
                        res = "请输入职员姓名";
                        break;
                }
                return res;
            },
            dataList(){  //数据列表
                return this.data.list;
            },
            maxIds(){   //列表中可删除的BU id合集
                return this.dataList.reduce((arr,item)=>{
                    if(item.type == 0){
                        arr.push(item.id);
                    }
                    return arr;
                },[]);
            },
        },

        created(){
            this.fresh();
        },

        methods:{
            fresh(obj={}){  //获取数据
                let url = `api/admin/bu_employee/bu/list`;
                this.$http.get(url,{params:obj}).then(res=>{
                    if(res.status == 200){
                        this.data = {list : res.res_data}; 
                    }
                });
            },

            checkList(event){ //全选
                this.deleteIds = event.target.checked?[...this.maxIds]:[];
            },
            changeCheck(){  //单选
                this.checkall = this.deleteIds.length === this.maxIds.length;
            },

            //***按钮们
            searchBu(){ //搜索BU
                let text = this.searchText;
                let obj = {};
                if(this.searchType == 1){
                    obj.bu_name = text;
                }else if(this.searchType == 2){
                    obj.employee_name = text;
                }
                this.fresh(obj);
            },
            newBu(){  //新建BU
                this.$router.push({
                    name:'back-person-create-bu',
                });
            },
            deleteBu(id){  //删除BU
                let arr = id?[id]:this.deleteIds;
                this.$func.loading(true);
                let url = `api/admin/bu_employee/bu/delete`;
                this.$http.post(url,{
                    bu_ids:arr.join(','),
                }).then(res=>{
                    if(res.status ==200){
                        this.fresh();
                        this.successTip("删除成功");
                    }
                    this.$func.loading(false);
                }).catch(err=>{
                    this.errorTip('出错了');
                    this.$func.loading(false);
                });
            },
            addPerson(){  //添加职员
                this.$router.push({
                    name:'back-person-bu-addPerson',
                })
            },

            // ***其余
            link(item){
                let str= this.$crypto.encrypt(item.id);
                this.$router.push({ 
                    name: 'back-person-bu-detail', 
                    params: { 
                        buId: str 
                    },
                    // query:{
                    //     name:item.bu_name,
                    //     type: item.type,
                    // }
                });
            },
        },
        // beforeRouteLeave(to,from,next){  //离开页面之前
		// 	let res = this.$form.leave({name:'',path:to.path});
		// 	next(res);
		// },
    }
</script>

<style lang="less">
    @import "~src/assets/less/backless/var.less";

    .z-BUlist{
        .top-input{
            // display:inline-block;
            width:220px;
            .el-select,.el-input{
                min-width:100px;
                width:100px;
            }
        }

        .link-name{
            color:@blue;
            cursor:pointer;
        }

        .list-head,.list-item{
            >div:nth-of-type(1){
                width: 10%;
                height:100%;
                position: relative;
            }
            >div:nth-of-type(2){
                width: 17%;
                padding-right: 3%;
            }
            >div:nth-of-type(3){
                width: 30%;
                padding-right: 5%;
            }
            >div:nth-of-type(4){
                width: 25%;
            }
            >div:last-of-type{
                width: 10%;
                position:relative;
                .download{
                    position:absolute;
                    right:calc(~"100% + 30px");
                    white-space: nowrap;
                    color:@blue;
                    text-decoration:underline;
                    cursor:pointer;
                    &:hover{
                        color: #2493ff;
                    }
                    &:active{
                        color:#0081ff;
                    }
                }
                .back-btn{
                    color:#fff;
                    transform:translateX(-25%);
                }
                .red{
                    color:@red;
                    cursor:pointer;
                }
            }
        }

    }
    // .top-choose >input:last-child{
    //     width:100px;
    // }
</style>





// WEBPACK FOOTER //
// page-bu-list.vue?eda56c9e